/**
 * Keyword search component.
 */

/** Dependencies -------------------------------------------- */

// External

import classNames from 'classnames'

import Chip from '@mui/material/Chip';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

// Internal

import { getPlugin } from '../dictionary'
import { useAppState } from '../state'

/** Constants ----------------------------------------------- */

const baseClassName = 'keyword-search'

/** Components ---------------------------------------------- */

export default function KeywordSearch( props ) {

    // Constants

    const plugin = getPlugin()

    const keywordsFilter = useAppState( ( state ) => state.keywordsFilter )
    const filterByKeywords = useAppState( ( state ) => state.filterByKeywords )

    const normalizedValue = keywordsFilter ?? []

    const {
        className,
        ...additionalProps
    } = props

    const renderTags = function( value, getTagProps ) {
        return value.map( ( option, index ) => {
            const { key, ...tagProps } = getTagProps( { index } )
            return <Chip variant="outlined" label={ option.label ?? option } key={ key } { ...tagProps }/>
        } )
    }

    const renderInput = function( inputProps ) {
        return <TextField label="Search keywords" placeholder="Search keywords..." { ...inputProps }/>
    }

    const consolidatedClassName = classNames(
        baseClassName,
        className
    )

    // Handlers

    function handleChange( event, value ) {
        filterByKeywords( value )
    }

    // Exp zone

    return (
        <Autocomplete
            className={ consolidatedClassName }
            componentsProps={ { popper: { className: `${baseClassName}__popover` } } }
            freeSolo
            multiple
            options={ plugin.keywords }
            renderTags={ renderTags }
            renderInput={ renderInput }
            value={ normalizedValue }
            onChange={ handleChange }
      />
    )
}